var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeads2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 21V15C14.833 14.4696 14.6223 13.9609 14.2472 13.5858C13.8721 13.2107 13.3634 13 12.833 13H10.833C10.3026 13 9.79387 13.2107 9.41879 13.5858C9.04372 13.9609 8.83301 14.4696 8.83301 15V21",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.818 9.364L20.124 3.435C20.0881 3.30965 20.0124 3.19939 19.9083 3.1209C19.8042 3.04241 19.6774 2.99997 19.547 3H15.5L15.975 8.704C15.9822 8.79572 16.0112 8.8844 16.0595 8.96267C16.1079 9.04094 16.1742 9.10653 16.253 9.154C16.643 9.387 17.405 9.817 18 10C19.016 10.313 20.5 10.2 21.346 10.096C21.4282 10.0854 21.5072 10.0569 21.5773 10.0126C21.6474 9.96835 21.707 9.9093 21.752 9.8396C21.7969 9.7699 21.8261 9.69123 21.8375 9.60909C21.8489 9.52695 21.8423 9.44331 21.818 9.364Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 10C14.5683 9.825 15.2883 9.426 15.6903 9.188C15.784 9.13222 15.86 9.05108 15.9096 8.95393C15.9591 8.85678 15.9802 8.7476 15.9703 8.639L15.5003 3H8.50029L8.03029 8.639C8.02023 8.74777 8.04118 8.85716 8.09074 8.9545C8.1403 9.05184 8.21642 9.13315 8.31029 9.189C8.71229 9.426 9.43229 9.825 10.0003 10C11.4933 10.46 12.5073 10.46 14.0003 10Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87605 3.435L2.18205 9.365C2.15814 9.44418 2.15175 9.52762 2.16332 9.60951C2.17489 9.69141 2.20414 9.76981 2.24905 9.83927C2.29396 9.90873 2.35345 9.96758 2.42339 10.0117C2.49332 10.0559 2.57203 10.0843 2.65405 10.095C3.49905 10.2 4.98405 10.312 6.00005 10C6.59505 9.817 7.35805 9.387 7.74705 9.155C7.82599 9.10743 7.89241 9.04168 7.94077 8.96323C7.98913 8.88477 8.01803 8.79589 8.02505 8.704L8.50005 3H4.45305C4.32267 2.99997 4.19583 3.04241 4.09172 3.1209C3.98762 3.19939 3.91191 3.30965 3.87605 3.435Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads2);
export default __webpack_public_path__ + "static/media/leads2.1728be589ff923389e6781865a979baa.svg";
export { ForwardRef as ReactComponent };